export async function applyHyphenation() {
  let hyphenate;

  try {
    hyphenate = (await import(/* webpackChunkName: "hyphen-de" */ "hyphen/de")).hyphenate;
  } catch (error) {
    console.error("Hyphenation module not found for the current language:", error);
    return;
  }

  const elements = document.querySelectorAll('.js-hyphen');

  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    const originalText = element.innerText;
    const hyphenatedText = await hyphenate(originalText);
    element.innerText = hyphenatedText;
  }
}
